module.exports = __webpack_public_path__ + "static/media/AI-屏幕（摄像头）.7ca8d9bc.jpg";